import React, { useEffect, useRef, useState } from 'react';
import './ColumnCustomizer.css';

const ColumnCustomizer = ({
  columnLabels,
  visibleColumns,
  onChange,
  iconOnly = false,
  ariaLabel,
  label
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const visibleLabel = label || ariaLabel || 'Customize columns';
  const accessibleLabel = ariaLabel || label || 'Customize columns';

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <div className="column-customizer" ref={ref}>
      <button
        type="button"
        className={`btn btn-secondary btn-sm column-customizer-btn${iconOnly ? ' column-customizer-btn-icon' : ''}`}
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
        aria-haspopup="true"
        aria-label={accessibleLabel}
        title={accessibleLabel}
      >
        <span className="material-symbols-outlined" aria-hidden="true">view_column</span>
        {!iconOnly && visibleLabel}
      </button>
      {open && (
        <div className="column-customizer-dropdown" role="menu">
          {Object.entries(columnLabels).map(([key, label]) => (
            <label key={key} className="column-customizer-item">
              <input
                type="checkbox"
                checked={visibleColumns[key]}
                onChange={(e) => onChange(key, e.target.checked)}
              />
              <span>{label}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default ColumnCustomizer;
